'use client'
import {
  useUi
} from "./chunk-Y3GT52GT.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Calendar/DayPicker.tsx
import { DayPicker as Picker, getDefaultClassNames } from "react-day-picker";
import { arSA, enGB, fr } from "react-day-picker/locale";
import { useRouter } from "@wbk/config";
import styles from "react-day-picker/dist/style.module.css";
import { jsx } from "react/jsx-runtime";
var DayPicker = (_a) => {
  var _b = _a, { classNames, disabled } = _b, props = __objRest(_b, ["classNames", "disabled"]);
  const { locale } = useRouter();
  const { dir } = useUi();
  const defaultClassNames = getDefaultClassNames();
  return /* @__PURE__ */ jsx(
    Picker,
    __spreadValues({
      classNames: __spreadValues(__spreadProps(__spreadValues({}, styles), {
        root: `${styles.root} !w-full !m-0`,
        today: "font-bold",
        nav: `${styles.nav} w-full justify-between`,
        months: `${styles.months} max-w-full`,
        month_grid: `${styles.month_grid} !w-full !max-w-full table-fixed`,
        month: `${defaultClassNames.month} grow basis-[calc(50%_-_2rem)]`,
        weekday: `${styles.weekday} !p-1 !text-text-secondary`,
        month_caption: `${styles.month_caption} h-auto min-h-11 justify-center`,
        day: `${styles.day} !p-0 rounded-S`,
        chevron: `${styles.chevron} fill-text`,
        button_previous: `${styles.button_previous} !rounded-S !py-2 !m-px enabled:!cursor-pointer enabled:hover:!bg-primary/30 enabled:focus:!bg-primary/30 !rounded-S aria-disabled:!cursor-not-allowed`,
        button_next: `${styles.button_next} !rounded-S !py-2 !m-px enabled:!cursor-pointer enabled:hover:!bg-primary/30 enabled:focus:!bg-primary/30 !rounded-S aria-disabled:!cursor-not-allowed`,
        day_button: "w-full h-full !rounded-S !py-2 !m-px enabled:!cursor-pointer enabled:hover:!bg-primary/30 enabled:focus:!bg-primary/30 !rounded-S disabled:!cursor-not-allowed",
        selected: "!text-primary-contrast !bg-primary enabled:hover:!bg-primary/80 !text-primary enabled:focus:!bg-primary/80 enabled:focus:!bg-primary/80",
        range_start: "!bg-primary !text-primary-contrast ltr:!rounded-r-none rtl:!rounded-l-none",
        range_end: "!bg-primary !text-primary-contrast ltr:!rounded-l-none rtl:!rounded-r-none",
        range_middle: "!rounded-none !bg-primary/40 !text-primary-contrast",
        outside: "!opacity-100"
      }), classNames),
      dir,
      locale: (locale == null ? void 0 : locale.startsWith("ar")) ? arSA : (locale == null ? void 0 : locale.startsWith("fr")) ? fr : enGB,
      weekStartsOn: 0,
      disabled: disabled || (props.startMonth || props.endMonth ? [
        ...props.startMonth ? [{ before: props.startMonth }] : [],
        ...props.endMonth ? [{ after: props.endMonth }] : []
      ] : void 0)
    }, props)
  );
};
var DayPicker_default = DayPicker;

export {
  DayPicker_default
};
//# sourceMappingURL=chunk-WVR6ZI2O.mjs.map